import React, { useEffect, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import InputGroupText from "react-bootstrap/esm/InputGroupText";
import { Chart } from "react-google-charts";
// { x: "Male", value: 110, fill: "#6a9dd9" },
// { x: "Female", value: 120, fill: "#f5b7d1" },]}
import './Analytics.scss'
import { departmentAnalytics, genderAnalytics, programmeAnalytics } from "../../../shared/settings/apiConfig";
import { getApi, postApi } from "../../../shared/services/apiHelper";
export default function Analytics(props) {

    const [search, setSearch] = useState("");
    const [genderData, setGenderData] = useState({});
    const [programData, setProgramData] = useState({});
    const [departmentData, setDepartmentData] = useState({});
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const handleResize = () => {
        setWindowWidth(window.innerWidth);
    };

    useEffect(() => {
        getAnalyticsData();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    let optionspie = {
        title: "",
        is3D: true,
        pieStartAngle: 100,
        sliceVisibilityThreshold: 0.02,
        legend: { position: 'bottom', alignment: "end" },
        colors: ["#6a9dd9", "#f5b7d1"],
        seriesType: 'bars',
        isStacked: true,

    };

    const getAnalyticsData = () => {
        Promise.all([getGenderList(), getprogramList(), getDepartmentList()]).then(responses => {
            let genderData = responses[0];
            let programData = responses[1];
            let departmentData = responses[2];
            setGenderData(genderData);
            setProgramData(programData);
            setDepartmentData(departmentData);
        })
    }

    const getGenderList = () => {
        let payload = {filter: []};
        return new Promise((resolve, reject) => {
            postApi(genderAnalytics, payload).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    };

    const getprogramList = () => {
        let payload = {filter: []};
        return new Promise((resolve, reject) => {
            postApi(programmeAnalytics, payload).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    };

    const getDepartmentList = () => {
        let payload = {filter: []};
        return new Promise((resolve, reject) => {
            postApi(departmentAnalytics, payload).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    };

    return (
        <div className="analytics-component">
            <text className='screen-head'>Assessment Analytics</text>
            <div>
                <div className="w-100 d-flex gap-2 rightcont">
                    <div className="w-50"></div>

                    <InputGroup className="p-5">
                        <InputGroupText className="signicon search" >
                            <i class="fa fa-search text-primary" ></i>
                        </InputGroupText>
                        <span class="icon-envelope-o"></span>
                        <Form.Control className={`signinput search`} size="md" type={'text'} name={"search"} placeholder={"Search by Date (from-to) Department / Faculty / Programme / Subject / Assessment Cycle / Assessment"} value={search}
                            onChange={(event) => { setSearch(event.target.value) }} autoComplete="off" onKeyPress={(event) => {
                                if (event?.key === "Enter") { }
                            }} />
                        <InputGroupText role={"button"} className="border border-1 search  bg-primary" onClick={() => {
                        }}>
                            {windowWidth > 800 ? <div className="text-white">Search</div> : <i class="fa fa-search text-white" ></i>}
                        </InputGroupText>
                        <Button className="bg-secondary" type="button" style={{ marginLeft: '3px' }} onClick={(event) => {
                        }}>
                            {windowWidth > 800 ? <div className="text-white">Clear</div> : <i class="fa fa-times text-white" ></i>}</Button>
                    </InputGroup>
                </div>

                <div className="d-flex gap-2 p-3">
                    <div className="shadow-lg">
                        <Chart
                            chartType="PieChart"
                            data={genderData}
                            options={{ ...optionspie, title: "Assessee Gender", colors: ["#f8b9d4", "#6ca0dc"] }}
                            width={"100%"}
                            height={"300px"}
                        />

                    </div>
                    <div className="shadow-lg">
                        <Chart
                            chartType="Bar"
                            data={programData}
                            options={{ ...optionspie, title: "Assessee Stream", colors: ["#f8b9d4", "#6ca0dc"] }}
                            width={"100%"}
                            height={"300px"}
                        />
                    </div>
                </div>

                <div className="d-flex gap-2 my-5 p-3 w-50">
                    <div className="shadow-lg">
                        <Chart
                            chartType="BarChart"
                            data={departmentData}
                            options={{ ...optionspie, colors: ["#ADD8E6", "#767171"], title: "Assessment Programme", isStacked: false }}
                            width={"100%"}
                            height={"300px"}
                        />
                    </div>
                    {/* <div className="shadow-lg">
                        <Chart
                            chartType="BarChart"
                            data={[
                                ["Assessment Status", "Undergraduate", "Postgraduate"],
                                ["yet to start", 110, 120],
                                ["started", 120, 150],
                                ["completed", 120, 50]
                            ]}
                            options={{ ...optionspie, colors: ["#ADD8E6", "#767171"], title: "Assessment Status" }}
                            width={"100%"}
                            height={"300px"}
                        />
                    </div> */}
                </div>
                {/* <div className="d-flex gap-2 my-5 p-3">
                    <div className="shadow-lg">
                        <Chart
                            chartType="ComboChart"
                            data={[
                                ["Assessment Performance", "Over 81%", "60 to 80%", "Less than 59%"],
                                ["Undergraduate", 80, 50, 50],
                                ["Postgraduate", 20, 50, 20],
                            ]}
                            options={{ ...optionspie, title: "Assessment Performance", colors: ["#a9d18d", "#FFD700", "#a5a5a5"] }}
                            width={"100%"}
                            height={"300px"}
                        />
                    </div>
                    <div className="shadow-lg">
                        <Chart
                            chartType="Bar"
                            data={[
                                ["Students Performance by Faculty", "Over 81%", "60 to 80%", "Less than 59%"],
                                ["Dr. Aanya", 80, 50, 50],
                                ["Mrs. Abhaya", 20, 10, 20],
                                ["Mrs. Banu", 20, 10, 20],
                                ["Mrs. Srinisha", 20, 10, 20],
                            ]}
                            options={{ ...optionspie, title: "Students Performance by Faculty", colors: ["#a9d18d", "#FFD700", "#a5a5a5"] }}
                            width={"100%"}
                            height={"300px"}
                        />
                    </div>
                </div> */}
                {/* <div className="d-flex gap-2 my-5 p-3">
                    <div className="w-50">
                        <Chart
                            chartType="Bar"
                            data={[
                                ["Assessment Subject", "Over 81%", "60 to 80%", "Less than 59%"],
                                ["BSC", 80, 50, 50],
                                ["BCOM", 20, 10, 20],
                                ["BE", 20, 30, 20],
                                ["Maths", 20, 90, 10],
                                ["MSC", 40, 10, 5],
                                ["B.Tech", 60, 25, 10],
                            ]}
                            options={{ ...optionspie, title: "Subject wise peformance", colors: ["#a9d18d", "#FFD700", "#a5a5a5"] }}
                            width={"100%"}
                            height={"300px"}
                        />
                    </div>
                </div> */}
            </div>
        </div>
    )
}